import "./ActionTypeBadge.css";

const ACTION_TYPE_CLASSNAMES = {
    create: "action-type-badge create",
    update: "action-type-badge update",
    delete: "action-type-badge delete",
    warning: "action-type-badge warning",
};

function ActionTypeBadge({ value }) {
    const className = ACTION_TYPE_CLASSNAMES[value] || "action-type-badge info";
    return (
        <div className="action-type-badge-container">
            <span className={className}>{(value || "info").toUpperCase()}</span>
        </div>
    );
}

export default ActionTypeBadge;
